import { type CountryCode, type LocationId, COUNTRY_CODES, buildLocationOneLine } from '@terros/common'
import { type SelectItem } from '../types'
import { useLocation } from './get'

export function useLocationAddress(locationId: LocationId | undefined): string {
  const { isLoading, error, data: location } = useLocation(locationId)
  if (isLoading) return 'Loading'
  if (error) return 'Failed to load address: ' + error
  if (!location) return 'Address not found'
  return buildLocationOneLine(location)
}

export const COUNTRY_CODE_ITEMS: SelectItem<CountryCode>[] = COUNTRY_CODES.map((cc) => ({
  label: longFormCountry(cc),
  value: cc,
}))

function longFormCountry(countryCode: CountryCode): string {
  switch (countryCode) {
    case 'US':
      return 'United States'
    case 'CA':
      return 'Canada'
    case 'PR':
      return 'Puerto Rico'
    default:
      return countryCode
  }
}
